module.exports = __webpack_public_path__ + "static/media/wolffox5_preview.4fee5894.jpg";